const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Overview Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Overview', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/overview/:subresource', null, {
    totals: {params: {subresource: ''}, method: 'GET', isArray: false},
    resolve: {params: {subresource: 'resolve'}, method: 'POST', isArray: true}
  });
}]);
